<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal(false)">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title class="ion-title-icon">{{'Mensagens' | translate}}</ion-title>

    <ion-col class="end-filter" (click)="delete(mensagem)">
      <i class="fa-light fa-trash-can"></i>
    </ion-col>
  </ion-buttons>
</ion-header>

<ion-content *ngIf="!loaded">
  <app-loading-spinner></app-loading-spinner>
</ion-content>

<ion-content *ngIf="loaded">
  <div class="gradient-extendido"></div>

  <div *ngIf="mensagem.id" class="top">
    <ion-list class="remove-border">
      <ion-item>
        <ion-avatar slot="start">
          <img
            [src]="((mensagem.criador && mensagem.criador.foto) ? mensagem.criador.foto : '') | image:' '"
            class="avatar-image"
          />
        </ion-avatar>

        <ion-label>
          <h2 class="bold-2 title">{{mensagem.titulo | translate}}</h2>

          <p class="message">
            {{mensagem.created_at | dateFormat:'dataHora' }}
          </p>
        </ion-label>
      </ion-item>
    </ion-list>

    <ion-card-content style="margin: 18px">
      <p [innerHTML]="mensagem.conteudo | safeHtml: 'html'"></p>
    </ion-card-content>

    <ion-list *ngIf="mensagem.links && mensagem.links.length">
      <ion-item-group>
        <ion-list-header class="conteudo-desc bold-2"
          >{{'Links' | translate}}</ion-list-header
        >
        <ion-item *ngFor="let links of mensagem.links" (click)="openLink(links, mensagem.entidade)">
          {{links.nome}}

          <ion-icon name="open-outline" slot="end"></ion-icon>
        </ion-item>
      </ion-item-group>
    </ion-list>

    <div *ngIf="mensagem.audios && mensagem.audios.length">
      <ion-list-header class="conteudo-desc bold-2"
        >{{'Conteúdo Adicional' | translate}}</ion-list-header
      >
      <ion-list class="conteudo-list">
        <ion-item *ngIf="mensagem.audios.length" (click)="openAudios()">
          <ion-avatar slot="start">
            <i class="fas fa-volume-up conteudo-icon"></i>
          </ion-avatar>

          <p class="conteudo-mensagem bold-1">{{'Áudios' | translate}}</p>

          <ion-note slot="end">
            <p>{{mensagem.audios.length}}</p>
          </ion-note>
        </ion-item>
      </ion-list>
    </div>
  </div>
</ion-content>
